module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.4534/img/storefront-header-blobs.svg"